import React from 'react';
import BaseField, {
	BaseFieldProps,
} from '../../../../Modules/Base/Components/Inputs/BaseField/BaseField';
import TimePicker from '../../../Base/TimePicker/TimePicker';

const TimePickerField: React.FC<BaseFieldProps> = props => (
	<BaseField {...props}>
		<TimePicker />
	</BaseField>
);

export default TimePickerField;
